import {Route} from '@angular/router';
import {Observable} from 'rxjs';
import {loadedUserHoldsBuildingService, routeVisibilitySchema} from '@shared/route-utils';

/**
 * Restricts a route to users holding the service its own `requireBuildingService` names, so a tab
 * hidden from the strip is unreachable by URL as well. A user without it falls through to the
 * not-found route, exactly as a tab whose feature flag is off does.
 */
export const buildingServiceGuard = (route: Route): Observable<boolean> =>
    loadedUserHoldsBuildingService(
        routeVisibilitySchema.parse(route.data ?? {}).requireBuildingService,
    );
